import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const SubscriptionAgreementStyle = makeStyles()((theme: Theme) => ({
  content: {
    maxHeight: 'calc(100vh - 352px)',
    overflowY: 'scroll',
    paddingRight: '10px',
    wordBreak: 'break-word',

    '& p:first-child': {
      marginTop: 0,
    },

    '& p:last-child': {
      marginBottom: 0,
    },
  },
}))

export default SubscriptionAgreementStyle
